import Home from '@/views/Home.vue';

export const home = () => ([
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { title: 'Home' },
  },
]);
